import { useEffect, useState } from "react";
import { PhotoIcon } from "@heroicons/react/24/solid";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { baseUrl } from "../../../Environments/environment";
import { useAuth } from "../../../Contexts/AuthContext/AuthContext";
import { toast } from "react-toastify";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { apiClient } from "../../../api";
import { TrashIcon } from "lucide-react";

const steps = [
	{
		name: "Property SMS Subaccount",
		subtext:
			"Click proceed to continue onboarding, We're creating twilio sms accout for you here.",
		href: "#",
		status: "complete",
	},
	{
		name: "Buy phone number",
		subtext: "Click buy button to select phone numbers.",
		href: "#",
		status: "current",
	},
	{ name: "Integration Complete", subtext: "", href: "#", status: "upcoming" },
];

export default function AddProperty() {
	const { accessToken } = useAuth();
	const [currentStep, setCurrentStep] = useState(1);
	const location = useLocation();
	const { isComplete, propertyId, isSubaccountCreated, from } =
		location.state || {};
	const [propertyName, setPropertyName] = useState("");
	const [propertyEmail, setPropertyEmail] = useState("");
	const [website, setWebsite] = useState("");
	const [about, setAbout] = useState("");
	const [countryCode, setCountryCode] = useState("+1");
	const [country, setCountry] = useState("");
	const [iso2, setIso2] = useState("");
	const [state, setState] = useState("");
	const [city, setCity] = useState("");
	const [zipcode, setZipcode] = useState("");
	const [address, setAddress] = useState("");
	const [standardCheckinTime, setStandardCheckinTime] = useState("15:00");
	const [standardCheckoutTime, setStandardCheckoutTime] = useState("11:00");
	const [timezone, setTimezone] = useState("");
	const [defaultNewDayTime, setDefaultNewDayTime] = useState("");
	const [logo, setLogo] = useState(null);
	const [cover, setCover] = useState(null);
	const [logoName, setLogoName] = useState("");
	const [coverName, setCoverName] = useState("");
	const [firstForm, setFirstForm] = useState(true);
	const [secondForm, setSecondForm] = useState(false);
	const [thirdForm, setThirdForm] = useState(false);
	const [phoneNumbers, setPhoneNumbers] = useState([]);
	const [phoneNumber, setPhoneNumber] = useState();
	const [loading, setLoading] = useState(false);
	const [timezones, setTimezones] = useState([]);
	const [phoneBuy, setPhoneBuy] = useState(
		phoneNumbers.length > 0 ? phoneNumbers[0].phoneNumber : "",
	);
	const [logoUrl, setLogoUrl] = useState(null);
	const [coverUrl, setCoverUrl] = useState(null);
	const [nextContact, setNextContact] = useState(false);
	const [disableChange, setDisableChange] = useState(false);
	const [property, setProperty] = useState();
	const [countries, setCountries] = useState([]);
	const [propertyData, setPropertyData] = useState(null);
	const [mode, setMode] = useState("buy"); // "buy" | "host"
	const [isPropertyCreated, setIsPropertyCreated] = useState(false);

	const deleteCover = () => {
		setCover(null);
		setCoverUrl(null);
		setCoverName("");
	};

	useEffect(() => {
		if (isComplete === false) {
			const fetchData = async () => {
				setFirstForm(false);
				setSecondForm(false);
				setThirdForm(true);

				await fetchPropertyData(); // Await the fetchPropertyData function
			};

			fetchData(); // Call the async function
		}
	}, [isComplete]);

	console.log("phoneBuy", phoneBuy);
	const fetchPropertyData = async () => {
		try {
			const response = await apiClient.get(`${baseUrl}/property/${propertyId}`);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			console.log(response);

			const { _, setting } = response.data.result;
			const property = response.data.result.property.property;
			console.log(property);

			// Map the fetched data to your state variables
			setPropertyName(property.name || "");
			setPropertyEmail(property.email || "");
			setPhoneNumber(property.phoneNumber || "");
			setWebsite(property.website || "");
			setAbout(property.about || "");
			setCountry(property.country || "");
			setState(property.state || "");
			setCity(property.city || "");
			setAddress(property.address || "");
			setZipcode(property.zipcode || "");
			setCountryCode(property.countryCode || "");
			setLogo(property.logoUrl || null);
			setCover(property.coverUrl || null);
			setStandardCheckinTime(setting.standardCheckinTime || "");
			setStandardCheckoutTime(setting.standardCheckoutTime || "");
			setTimezone(setting.timezone || "");
			setLogoUrl(property.logoUrl || null);
			setCoverUrl(property.coverUrl || null);
			setDefaultNewDayTime(setting.defaultNewDayTime || "");
			setPropertyData(response.data);
			setProperty(property);
		} catch (error) {
			const errorMessage =
				error.response?.data?.message || "Error fetching property data.";
			console.log(error);
			toast.error(errorMessage);
		}
	};

	useEffect(() => {
		if (iso2) {
			console.log("helo", iso2);
			//fetchPhoneNumbers();
		}
	}, [iso2]);

	const fetchPhoneNumbers = async () => {
		try {
			const response = await apiClient.get(
				`${baseUrl}/twilio/phoneNumbers?country=${iso2}`,
			);

			setPhoneNumbers(response.data.result.phoneNumbers);
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Error fetching phone numbers. Please try again.";
			toast.error(errorMessage);
		}
	};
	const handleCountryChange = (e) => {
		const selectedCountry = e.target.value;
		const selectedCountryIso2 =
			countries.find((countryItem) => countryItem.name === selectedCountry)
				?.iso2 || "";
		setCountry(selectedCountry);
		setIso2(selectedCountryIso2);
	};

	const fetchCountries = async () => {
		try {
			const response = await apiClient.get(`${baseUrl}/country`);

			setCountries(response.data.result.countries);
			if (property && property.country) {
				console.log("here");
				const iso2 = countries.find(
					(countryItem) => countryItem.name === property.country,
				)?.iso2;
				setIso2(iso2);
			}
		} catch (error) {
			console.log(error);
			const errorMessage =
				error.response?.data?.message || "Error fetching countries.";
			toast.error(errorMessage);
			console.error("Error fetching countries:", errorMessage);
		}
	};

	useEffect(() => {
		fetchCountries();
	}, [accessToken, property]);

	// Fetch timezones when the selected country changes
	useEffect(() => {
		if (country) {
			const fetchTimezones = async () => {
				try {
					if (!iso2) {
						return;
					}
					const response = await apiClient.get(
						`${baseUrl}/country/${iso2}/timezones`,
					);

					setTimezones(response.data.result.timezones); // Adjusted to handle new response structure
				} catch (error) {
					toast.error("Error fetching timezones.");
				}
			};

			fetchTimezones();
		}
	}, [country, iso2]);

	const fetchLocationData = async () => {
		try {
			const response = await apiClient.get(
				`${baseUrl}/country/${iso2}/${zipcode}`,
			);

			const { place, state: fetchedState } = response.data.result.zipcodes;
			setCity(place);
			setState(fetchedState);
		} catch (error) {
			const errorMessage =
				error.response?.data?.message || "Error fetching location data.";
			toast.error(errorMessage);
		}
	};
	const navigate = useNavigate();

	console.log("from", from);
	const handleBackToSource = () => {
		if (from === "propertyhome") {
			navigate("/propertyhome");
		} else if (from === "twilio-setup") {
			navigate("/twilio-setup");
		} else {
			navigate("/dashboard");
		}
	};

	// property onboard api call
	const handleSubmit = async (e) => {
		if (!isPropertyCreated) {
			e.preventDefault();

			setLoading(true); // Set loading state to true when form submission starts

			const formData = new FormData();
			formData.append("name", propertyName);
			formData.append("email", propertyEmail);
			if (!website.startsWith("https://")) {
				setWebsite((prevWebsite) => {
					return `https://${prevWebsite}`;
				});
			}
			formData.append("website", website);
			// formData.append("about", about);
			if (about !== "") formData.append("about", about);
			formData.append("phoneNumber", phoneNumber);
			formData.append("countryCode", countryCode);
			formData.append("country", country);
			formData.append("state", state);
			formData.append("city", city);
			formData.append("zipcode", zipcode);
			formData.append("address", address);
			formData.append("standardCheckinTime", standardCheckinTime);
			formData.append("standardCheckoutTime", standardCheckoutTime);
			formData.append("timezone", timezone);
			formData.append("defaultNewDayTime", defaultNewDayTime);
			if (logo) formData.append("logo", logo);
			if (cover) formData.append("cover", cover);

			try {
				let response;

				if (isComplete === false) {
					// Update existing property
					response = await apiClient.put(
						`${baseUrl}/property/${propertyId}`,
						formData,
						{
							headers: {
								"Content-Type": "multipart/form-data",
								Authorization: `Bearer ${accessToken}`,
							},
							withCredentials: true,
						},
					);
					if (response.ok) {
						const newToken = response.headers.get("Authorization");
						if (newToken) {
							localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
						}
					}
					toast.success("Property updated successfully!");
					setProperty(response.data.result.property);
					// Refresh the properties list in localStorage
					await refreshPropertiesList();
					setSecondForm(false);
					setThirdForm(true);
				} else {
					// Create a new property
					response = await apiClient.post(`${baseUrl}/property`, formData, {
						headers: {
							"Content-Type": "multipart/form-data",
							Authorization: `Bearer ${accessToken}`,
						},
						withCredentials: true,
					});

					toast.success("Property added successfully!");
					setProperty(response.data.result.property);
					// Refresh the properties list in localStorage
					await refreshPropertiesList();
					navigate("/dashboard");
					setSecondForm(false);
					setThirdForm(true);
				}

				console.log(
					isComplete === false ? "Updated property" : "Added property",
					response.data,
				);
				setIsPropertyCreated(true);
			} catch (error) {
				const errorMessage =
					error.response?.data?.message || "Error in Property details";
				toast.error(errorMessage);
				console.error("Error:", errorMessage);
			} finally {
				setLoading(false); // Set loading state to false after the API call completes or fails
			}
		} else {
			setSecondForm(false);
			setThirdForm(true);
		}
	};

	const handleProcessedButton = async () => {
		if (isSubaccountCreated) {
			setCurrentStep(2);
			return;
		}

		setLoading(true); // Set loading state to true when API call starts

		try {
			const response = await apiClient.post(
				`${baseUrl}/twilio/${property._id}/createSubaccount`,
				{},
			);

			console.log(response.data);
			toast.success("Subaccount created successfully!");
			setCurrentStep(2);
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to create subaccount. Please try again.";
			toast.error(errorMessage);
			console.error("Error:", errorMessage);
		} finally {
			setLoading(false);
		}
	};

	const handleFinishProcess = async () => {
		setLoading(true); // Set loading state to true when API call starts

		try {
			const url =
				mode === "buy"
					? `${baseUrl}/twilio/${property._id}/buyPhoneNumber`
					: `${baseUrl}/twilio/${property._id}/hostPhoneNumber`;

			const response = await apiClient.post(url, {
				phoneNumber: phoneBuy,
			});

			const successMessage =
				mode === "buy"
					? "Phone number purchased successfully!"
					: "Our team will contact you soon to configure your phone number!";
			toast.success(successMessage);
			setCurrentStep(4);
		} catch (error) {
			setCurrentStep(2);
			const errorMessage =
				error.response?.data?.message ||
				"Failed to purchase phone number. Please try again.";
			toast.error(errorMessage);
			console.error("Error purchasing phone number:", errorMessage);
		} finally {
			setLoading(false);
		}
	};

	const phoneRegex = /^\d{10}$/;
	const handlePhoneNumberChange = () => {
		if (mode === "host") {
			if (!phoneRegex.test(phoneBuy)) {
				toast.error("Please enter a valid 10-digit phone number.");
				return;
			}
		}
		if (mode === "buy") {
			if (!phoneBuy) {
				toast.error("Please select a phone number to proceed.");
				return;
			}
		}
		setCurrentStep(3);
		setDisableChange(true);
	};
	const handleSaveChange = () => {
		setDisableChange(false);
	};

	const handleNextContact = () => {
		setNextContact(true);
		fetchPhoneNumbers();
	};

	const handleNextButton1 = () => {
		setFirstForm(false);
		setSecondForm(true);
	};

	const handleBackButton1 = () => {
		setFirstForm(true);
		setSecondForm(false);
	};
	const handleBackButton2 = () => {
		if (from === "twilio-setup") {
			navigate("/dashboard/configure/twilio");
			return;
		}
		setSecondForm(true);
		setThirdForm(false);
	};

	const handleTimezoneChange = (e) => {
		const selectedIndex = e.target.selectedIndex; // Get the index of the selected option
		const selectedOption = e.target.options[selectedIndex].text; // Get the text of the selected option

		setTimezone(selectedOption);
	};

	const refreshPropertiesList = async () => {
		try {
			const response = await apiClient.get(`${baseUrl}/property`);
			if (response.data.result.properties) {
				const propertiesList = JSON.stringify(response.data.result.properties);
				localStorage.setItem("properties", propertiesList);
			}
		} catch (error) {
			console.error("Error refreshing properties list:", error);
		}
	};

	return (
		<>
			{loading && <LoadingSpinner />}
			<div className="min-h-screen bg-gray-300 px-4 py-8 md:px-8 md:py-12">
				<div className="mx-auto w-full max-w-6xl">
					<div className="mb-5 text-center sm:mb-6">
						<h2 className="text-3xl font-black text-black sm:text-4xl">
							Welcome Onboard!
						</h2>
						<p className="mt-2 text-base text-black sm:text-lg">
							We are few steps away to get started.
						</p>
						{firstForm && <p className="mt-2 font-bold text-black">Page 1/3</p>}
						{secondForm && (
							<p className="mt-2 font-bold text-black">Page 2/3</p>
						)}
						{thirdForm && <p className="mt-2 font-bold text-black">Page 3/3</p>}
					</div>
					{firstForm && (
						<form
							className="mx-auto bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl rounded-b-xl"
							onSubmit={handleNextButton1}
							// onClick={}
						>
							<div className="border-b border-gray-100 px-4 py-3 sm:px-8 sm:py-4">
								<button
									type="button"
									onClick={handleBackToSource}
									className="inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
								>
									<ArrowLeftIcon className="h-4 w-4" aria-hidden />
									Back
								</button>
							</div>
							<div className="px-4 py-6 sm:p-8">
								{/* form heading */}
								<div className="mb-4">
									<h2 className="text-2xl font-bold text-gray-900">
										Property Details
									</h2>
									<p className="mt-2 text-gray-600">
										This information will be displayed publicly so be careful
										what you share.
									</p>
								</div>

								<div className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6 sm:gap-x-6 sm:gap-y-8">
									{/* Cover photo */}
									<div className="col-span-full">
										<label
											htmlFor="cover-photo"
											className="block text-sm font-medium mb-2 text-gray-700"
										>
											Cover photo
										</label>
										<div className="mt-2 overflow-hidden rounded-xl border border-dashed border-gray-300 bg-gray-50">
											{coverUrl ? (
												<div className="relative">
													<div
														className="h-44 w-full bg-cover bg-center bg-no-repeat sm:h-56 md:h-64"
														style={{ backgroundImage: `url(${coverUrl})` }}
														role="img"
														aria-label="Property cover preview"
													/>
													<div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
													<div className="absolute bottom-3 right-3 z-20 flex items-center gap-2">
														<button
															type="button"
															onClick={deleteCover}
															className="inline-flex cursor-pointer items-center rounded-md bg-black/60 p-2 text-white hover:bg-black/70"
															aria-label="Remove cover image"
														>
															<TrashIcon className="h-4 w-4" />
														</button>
														<label
															htmlFor="cover-upload"
															className="cursor-pointer rounded-md bg-black/60 px-3 py-1.5 text-xs font-medium text-white hover:bg-black/70"
														>
															Change cover
															<input
																id="cover-upload"
																name="cover-upload"
																type="file"
																onChange={(e) => {
																	const file = e.target.files[0];

																	if (file) {
																		if (file.size > 10 * 1024 * 1024) {
																			alert(
																				"Please upload a file smaller than 10MB",
																			);
																			return;
																		}
																		setCoverUrl(URL.createObjectURL(file));
																		setCover(file);
																		setCoverName(file.name || "");
																	}
																}}
																className="sr-only"
															/>
														</label>
													</div>
												</div>
											) : (
												<div className="flex min-h-[190px] flex-col items-center justify-center px-4 py-10 text-center sm:min-h-[220px]">
													<PhotoIcon
														aria-hidden="true"
														className="mx-auto h-10 w-10 text-gray-300"
													/>
													<div className="mt-4 flex flex-wrap items-center justify-center text-sm leading-6 text-gray-600">
														<label
															htmlFor="cover-upload"
															className="relative cursor-pointer rounded-md bg-white px-1 font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
														>
															<span>Upload a file</span>
															<input
																id="cover-upload"
																name="cover-upload"
																type="file"
																onChange={(e) => {
																	const file = e.target.files[0];

																	if (file) {
																		if (file.size > 10 * 1024 * 1024) {
																			alert(
																				"Please upload a file smaller than 10MB",
																			);
																			return;
																		}
																		setCoverUrl(URL.createObjectURL(file));
																		setCover(file);
																		setCoverName(file.name || "");
																	}
																}}
																className="sr-only"
															/>
														</label>
														<p className="pl-1">or drag and drop</p>
													</div>
													<p className="text-xs leading-5 text-gray-600">
														PNG, JPG, GIF up to 10MB
													</p>
												</div>
											)}
										</div>
										{coverName && (
											<div className="mt-2 flex justify-end">
												<span className="max-w-full truncate text-right text-xs leading-5 text-green-600">
													{coverName}
												</span>
											</div>
										)}
									</div>

									<div className="col-span-full">
										<div className="grid grid-cols-1 gap-6 sm:grid-cols-6 sm:items-start">
											{/* Logo photo */}
											<div className="relative z-10 -mt-20 sm:col-span-1 sm:-mt-24 sm:pl-3">
												<div className="flex flex-col items-start">
													<label
														htmlFor="logo-upload"
														className="group relative flex h-28 w-28 cursor-pointer items-center justify-center overflow-hidden rounded-full border-2 border-dashed border-gray-400 bg-white shadow-sm transition hover:border-indigo-500 sm:h-32 sm:w-32"
													>
														{logoUrl ? (
															<img
																src={logoUrl}
																alt="Property logo preview"
																className="h-full w-full rounded-full object-cover"
															/>
														) : (
															<PhotoIcon
																aria-hidden="true"
																className="h-10 w-10 text-gray-400"
															/>
														)}
														<input
															id="logo-upload"
															name="logo-upload"
															type="file"
															required={
																propertyId || logoUrl !== null ? false : true
															}
															onChange={(e) => {
																if (e.target.files[0]) {
																	if (
																		e.target.files[0].size >
																		10 * 1024 * 1024
																	) {
																		alert(
																			"Please upload a file smaller than 10MB",
																		);
																		return;
																	}
																	setLogoUrl(
																		URL.createObjectURL(e.target.files[0]),
																	);
																	setLogo(e.target.files[0]);
																	setLogoName(e.target.files[0]?.name || "");
																}
															}}
															className="sr-only"
														/>
													</label>
													<p className="mt-3 w-28 text-center text-xs leading-5 text-gray-600 sm:w-32">
														PNG, JPG, GIF up to 10MB
													</p>
													{logoName && (
														<p className="mt-2 text-xs leading-5 text-green-600">
															{logoName}
														</p>
													)}
												</div>
											</div>

											<div className="sm:col-span-5 sm:pt-1">
												<div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
													<div>
														<label
															htmlFor="property-name"
															className="block text-sm font-medium  mb-2 text-gray-700"
														>
															Property Name
														</label>
														<div className="mt-2">
															<input
																id="property-name"
																name="property-name"
																type="text"
																required
																value={propertyName}
																onChange={(e) =>
																	setPropertyName(e.target.value)
																}
																placeholder="Enter property name"
																className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
															/>
														</div>
													</div>

													<div>
														<label
															htmlFor="property-email"
															className="block text-sm font-medium  mb-2 text-gray-700"
														>
															Property Contact Email
														</label>
														<div className="mt-2">
															<input
																id="property-email"
																name="property-email"
																type="email"
																required
																value={propertyEmail}
																onChange={(e) =>
																	setPropertyEmail(e.target.value)
																}
																placeholder="Enter property email"
																className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
															/>
														</div>
													</div>

													<div>
														<label
															htmlFor="property-phone-number"
															className="block text-sm font-medium  mb-2 text-gray-700"
														>
															Property Contact Mobile
														</label>
														<div className="mt-2 flex flex-col gap-3 sm:flex-row sm:items-stretch">
															<div className="shrink-0 sm:w-32">
																<label
																	htmlFor="property-country-code"
																	className="sr-only"
																>
																	Country calling code
																</label>
																<select
																	id="property-country-code"
																	value={countryCode}
																	onChange={(e) =>
																		setCountryCode(e.target.value)
																	}
																	className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none"
																>
																	<option value="+1">+1</option>
																	<option value="+91">+91</option>
																	<option value="+44">+44</option>
																	<option value="+61">+61</option>
																	{/* Add more country codes as needed */}
																</select>
															</div>
															<div className="min-w-0 flex-1">
																<input
																	id="property-phone-number"
																	name="property-phone-number"
																	type="tel"
																	required
																	value={phoneNumber}
																	onChange={(e) =>
																		setPhoneNumber(e.target.value)
																	}
																	placeholder="Phone number"
																	className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
																	minLength="10"
																	maxLength="10"
																	pattern="[0-9]*"
																/>
															</div>
														</div>
													</div>

													<div>
														<label
															htmlFor="website"
															className="block text-sm font-medium mb-2 text-gray-700"
														>
															Property Official Website
														</label>
														<div className="mt-2">
															<input
																id="website"
																name="website"
																type="text"
																required
																value={website}
																onChange={(e) => setWebsite(e.target.value)}
																placeholder="Enter property official website"
																className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
															/>
														</div>
													</div>

													<div className="sm:col-span-2">
														<label
															htmlFor="about"
															className="block text-sm font-medium mb-2 text-gray-700"
														>
															About
														</label>
														<div className="mt-2">
															<textarea
																id="about"
																name="about"
																rows={5}
																value={about}
																// required
																onChange={(e) => setAbout(e.target.value)}
																className="block w-full rounded-md border rows-2 border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
																placeholder="Wrtie something"
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 bg-gray-100 px-4 py-4 sm:px-8 rounded-b-xl">
								<button
									type="submit"
									className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
								>
									Save and Continue
								</button>
							</div>
						</form>
					)}

					{secondForm && (
						<form
							className="bg-white shadow-sm ring-1 ring-gray-900/5 rounded-xl md:col-span-2 lg:m-10 rounded-b-xl"
							onSubmit={handleSubmit}
						>
							<div className="px-4 py-6 sm:p-8">
								{/* form heading */}
								<div className="mb-4">
									<h2 className="text-2xl font-bold text-gray-900">
										Property Details
									</h2>
									<p className="mt-2 text-gray-600">
										This information will be displayed publicly so be careful
										what you share.
									</p>
								</div>

								<div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
									{/* Country */}
									<div className="sm:col-span-3">
										<label
											htmlFor="country"
											className="block text-sm font-medium mb-2 text-gray-700"
										>
											Country
										</label>
										<div className="mt-2">
											<select
												id="country"
												name="country"
												value={country}
												required
												onChange={handleCountryChange}
												onBlur={fetchPhoneNumbers}
												className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
											>
												<option value="">Select a country</option>
												{countries.map((countryItem) => (
													<option
														key={countryItem.iso2}
														value={countryItem.name}
													>
														{countryItem.name}
													</option>
												))}
											</select>
										</div>
									</div>

									{/* Zipcode */}
									<div className="sm:col-span-3">
										<label
											htmlFor="zipcode"
											className="block text-sm font-medium mb-2 text-gray-700"
										>
											Zipcode
										</label>
										<div className="mt-2">
											<input
												id="zipcode"
												name="zipcode"
												type="text"
												value={zipcode}
												required
												onChange={(e) => setZipcode(e.target.value)}
												onBlur={fetchLocationData}
												placeholder="Enter zipcode"
												className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
												minLength="5"
												maxLength="6"
											/>
										</div>
									</div>

									{/* State */}
									<div className="sm:col-span-3">
										<label
											htmlFor="state"
											className="block text-sm font-medium mb-2 text-gray-700"
										>
											State
										</label>
										<div className="mt-2">
											<input
												id="state"
												name="state"
												type="text"
												value={state}
												required
												onChange={(e) => setState(e.target.value)}
												placeholder="Enter state"
												className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
											/>
										</div>
									</div>

									{/* City */}
									<div className="sm:col-span-3">
										<label
											htmlFor="city"
											className="block text-sm font-medium mb-2 text-gray-700"
										>
											City
										</label>
										<div className="mt-2">
											<input
												id="city"
												name="city"
												type="text"
												value={city}
												required
												onChange={(e) => setCity(e.target.value)}
												placeholder="Enter city"
												className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
											/>
										</div>
									</div>

									{/* Address */}
									<div className="sm:col-span-full">
										<label
											htmlFor="address"
											className="block text-sm font-medium mb-2 text-gray-700"
										>
											Address
										</label>
										<div className="mt-2">
											<input
												id="address"
												name="address"
												type="text"
												required
												value={address}
												onChange={(e) => setAddress(e.target.value)}
												placeholder="Enter address"
												className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
											/>
										</div>
									</div>

									{/* Standard Check-In Time */}
									<div className="sm:col-span-3">
										<label
											htmlFor="check-in-time"
											className="block text-sm font-medium mb-2 text-gray-700"
										>
											Standard Check-In Time
										</label>
										<div className="mt-2">
											<input
												id="check-in-time"
												name="check-in-time"
												type="time"
												required
												value={standardCheckinTime}
												onChange={(e) => setStandardCheckinTime(e.target.value)}
												className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
											/>
										</div>
									</div>

									{/* Standard Check-Out Time */}
									<div className="sm:col-span-3">
										<label
											htmlFor="check-out-time"
											className="block text-sm font-medium mb-2 text-gray-700"
										>
											Standard Check-Out Time
										</label>
										<div className="mt-2">
											<input
												id="check-out-time"
												name="check-out-time"
												type="time"
												required
												value={standardCheckoutTime}
												onChange={(e) =>
													setStandardCheckoutTime(e.target.value)
												}
												className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
											/>
										</div>
									</div>

									{/* Timezone Selection */}
									<div className="sm:col-span-3">
										<label
											htmlFor="property-timezone"
											className="block text-sm font-medium mb-2 text-gray-700"
										>
											Property Timezone
										</label>
										<div className="mt-2">
											<select
												id="property-timezone"
												name="property-timezone"
												value={timezone} // Bind the value to the timezone state
												required
												onChange={handleTimezoneChange} // Handle change to update the state and dropdown
												className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
											>
												{timezone && (
													<option value={timezone}>{timezone}</option>
												)}
												<option value="">Select a timezone</option>
												{timezones.map((tz, index) => (
													<option
														key={index}
														value={`${tz.tzName} (${tz.gmtOffsetName})`}
													>
														{tz.tzName} ({tz.gmtOffsetName})
													</option>
												))}
											</select>
										</div>
									</div>

									{/* Your Property New Day Starts At */}
									<div className="sm:col-span-3">
										<label
											htmlFor="new-day-start-time"
											className="block text-sm font-medium mb-2 text-gray-700"
										>
											Your Property New Day Starts At
										</label>
										<div className="mt-2">
											<input
												id="new-day-start-time"
												name="new-day-start-time"
												type="time"
												value={defaultNewDayTime}
												onChange={(e) => setDefaultNewDayTime(e.target.value)}
												className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
											/>
										</div>
									</div>
								</div>
							</div>

							<div className="flex items-end justify-end gap-x-6 border-t border-gray-900/10 bg-gray-100 px-4 py-4 sm:px-8 rounded-b-xl">
								<button
									type="button"
									onClick={handleBackButton1} // Add a handler for the previous button
									className="rounded-md bg-gray-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
								>
									Previous
								</button>
								<button
									type="submit"
									// onClick={handleNextButton2}
									className="rounded-md bg-indigo-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
								>
									Save and Continue
								</button>
							</div>
						</form>
					)}

					{thirdForm && (
						<div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2 m-10 rounded-b-xl">
							<div className="px-4 py-6 sm:p-8">
								{/* form heading */}
								<div className="mb-4">
									<h2 className="text-2xl font-bold text-gray-900">
										Please wait while we are setting up the property account...
									</h2>
									<p className="mt-2 text-gray-600">
										This might take a few seconds only.
									</p>
								</div>

								{/* property account setting progress */}
								<div className="px- py-12 sm:px-6 lg:px-">
									<nav aria-label="Progress" className="">
										<ol role="list" className="space-y-12">
											{steps.map((step, index) => (
												<li key={step.name}>
													{index + 1 === currentStep ? (
														<>
															<div className="flex items-start">
																<span
																	aria-hidden="true"
																	className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center"
																>
																	<span className="absolute h-4 w-4 rounded-full bg-indigo-200" />
																	<span className="relative block h-2 w-2 rounded-full bg-indigo-600" />
																</span>
																<span className="ml-3 text-sm font-medium text-indigo-600">
																	{step.name}
																	<span className="block text-xs text-gray-400">
																		{step.subtext}
																	</span>
																</span>
															</div>
															{index === 0 && (
																<div className="flex items-end justify-end">
																	<button
																		onClick={handleProcessedButton}
																		className="mt-4 rounded-md bg-indigo-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
																	>
																		Processed
																	</button>
																</div>
															)}
															{index === 1 && !nextContact && (
																<div className="flex items-end justify-end">
																	<button
																		onClick={handleNextContact}
																		className="mt-4 rounded-md bg-indigo-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
																	>
																		Next
																	</button>
																</div>
															)}
														</>
													) : index + 1 < currentStep ? (
														<div className="flex items-start">
															<CheckCircleIcon
																aria-hidden="true"
																className="h-5 w-5 text-[#34D399]"
															/>
															<span className="ml-3 text-sm font-medium text-gray-500">
																{step.name}
															</span>
														</div>
													) : (
														<div className="flex items-start">
															<div
																aria-hidden="true"
																className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center"
															>
																<div className="h-2 w-2 rounded-full bg-gray-300" />
															</div>
															<span className="ml-3 text-sm font-medium text-gray-500">
																{step.name}
															</span>
														</div>
													)}
													{index === 1 && nextContact && (
														<div className="mt-4 ml-3">
															{/* Toggle Buttons */}
															<div className="flex gap-4 mb-4">
																<button
																	type="button"
																	onClick={() => {
																		setMode("buy");
																		setPhoneBuy("");
																	}}
																	disabled={disableChange}
																	className={`px-4 py-2 rounded-md text-sm font-medium ${
																		mode === "buy"
																			? "bg-indigo-600 text-white"
																			: "bg-gray-200 text-gray-700"
																	}`}
																>
																	Buy a phone number
																</button>
																<button
																	type="button"
																	onClick={() => {
																		setMode("host");
																		setPhoneBuy("");
																	}}
																	disabled={disableChange}
																	className={`px-4 py-2 rounded-md text-sm font-medium ${
																		mode === "host"
																			? "bg-indigo-600 text-white"
																			: "bg-gray-200 text-gray-700"
																	}`}
																>
																	Host a Number
																</button>
															</div>

															{/* Dropdown Mode */}
															{mode === "buy" && (
																<select
																	id="phoneNumberSelect"
																	className={`rounded-md border-gray-300 w-full ${
																		disableChange ? "opacity-40 disabled" : ""
																	}`}
																	disabled={disableChange}
																	onChange={(e) => setPhoneBuy(e.target.value)}
																	onBlur={handleSaveChange}
																	value={phoneBuy}
																>
																	<option value="">
																		Select a phone number
																	</option>
																	{phoneNumbers.map((number) => (
																		<option
																			key={number.phoneNumber}
																			value={number.phoneNumber}
																		>
																			{number.phoneNumber}
																		</option>
																	))}
																</select>
															)}

															{/* Input Mode */}
															{mode === "host" && (
																<>
																	<input
																		type="text"
																		placeholder="Enter phone number"
																		className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm"
																		value={phoneBuy}
																		minLenght="10"
																		maxLength="10"
																		onChange={(e) =>
																			setPhoneBuy(e.target.value)
																		}
																		disabled={disableChange}
																	/>
																	<span className="text-gray-500 text-xs mt-2">
																		We can use your existing business phone to
																		send messages to guests via our platform
																	</span>
																</>
															)}

															<p className="text-green-400 text-xs pt-4 text-right">
																Verification in progress. May require 5–7
																business days.
															</p>

															<div className="flex items-end justify-end">
																<button
																	onClick={() => handlePhoneNumberChange()}
																	className={`mt-6 rounded-md px-4 py-2 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
																		disableChange
																			? "bg-white text-gray-500 border border-gray-400 focus-visible:outline-gray-400"
																			: "bg-indigo-600 text-white focus-visible:outline-blue-600"
																	}`}
																>
																	Save Change
																</button>
															</div>
														</div>
													)}
												</li>
											))}
										</ol>
									</nav>
								</div>
							</div>

							{currentStep === 3 && (
								<div className="flex items-end justify-end mr-10 mb-10">
									{disableChange && (
										<button
											onClick={handleFinishProcess}
											className="rounded-md bg-indigo-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
										>
											Finish
										</button>
									)}
								</div>
							)}

              <div className="flex flex-col sm:flex-row max-sm:item-center sm:items-end sm:justify-end gap-2 sm:gap-x-6 border-t border-gray-900/10 bg-gray-100 px-4 py-4 sm:px-8 rounded-b-xl">
                <button
                  type="button"
                  onClick={handleBackButton2} // Add a handler for the previous button
                  className="rounded-md bg-gray-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                >
                  Previous
                </button>
                {currentStep === 4 && (
                  <button
                    type="submit"
                    className="rounded-md bg-indigo-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    <a href="/propertyhome">View Properties</a>
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
